import {createStore} from '../utilities/storeUtils';
import  _ from 'underscore';
import {abilitiesKeyToArrayOfAbilities} from './relationships';
import {isBlank, isTruthy} from '../utilities/general';

let abilities = {};

const defaults = {

};

const AbilityStore = createStore({
  storeEventBaseKey: "abilities",
  normalizr: abilitiesKeyToArrayOfAbilities,
  normalizrKey: "abilities",
  getData(){
    return abilities;
  },
  getDefaults(){
    return defaults;
  },
  ask(key){
    // For testing, uncomment
    // if(key === "canEditGtlAsn"){
    //   return false;
    // }
    const v = this.getData()[key] && this.getData()[key].value;
    // we make everything default to true,
    // unless explicitly set to false
    // (not truly happy about this, but
    //  alvin is not sending this key on
    //  create action, which break the logic)
    // By defaulting to true, we are allowed
    // edit in any case, unless explicity set to false
    return isBlank(v) || isTruthy(v);
  }
});


window.AbilityStore = AbilityStore;
export default AbilityStore;



// WEBPACK FOOTER //
// ./src/stores/AbilityStore.js